// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__014li","fab":"Navbar_fab__9kAAt","welcome":"Navbar_welcome__1ym+x"};